import React, {useEffect, useRef, useState } from "react";
import { BtnState } from "../interfaces/App";
import Icon, { IconType } from "./Icon";

interface IProps {
    ref?: any;
    id: string;
    type?: string;
    value: string;
    className?: string;
    label?: string | React.JSX.Element;
    placeholder?: string;
    autoComplete?: string;
    tabIndex?: number;
    disabled?: boolean;
    readOnly?: boolean;
    additional?: "eye" | React.JSX.Element;
    setState?: (name: string, value: string, isValid?: boolean) => void;
    checkValidity?: (value: string, mandatory?: boolean) => boolean;
    onBlur?: () => void;
    onDoubleClick?: () => void;
    mandatory?: boolean;
    validInfo?: React.JSX.Element | string;
    error?: boolean;
    showerror?: boolean;
    length?: number;
}
function CustomInputValidity(props: IProps) {
    const ref = useRef<HTMLInputElement>(props.ref);
    const [focus, setFocus] = useState(false);
    const [type, setType] = useState(props.type);
    const [error, setError] = useState(false);
    const [showerror, setShowError] = useState(false);
    const eye = () => {
        return !props.disabled ? (
            <div
                className="additional"
                onClick={() => setType(type === "password" ? "text" : "password")}
            >
                <Icon
                    icon={type === "text" ? IconType.eyeOff : IconType.eye}
                    state={BtnState.active}
                />
            </div>
        ) : (null);
    };
    const renderLabel = (label: string | React.JSX.Element) => {
        return label ? (
            <label
                htmlFor={props.id}
                className={props.value?.length || focus ? "animated" : ""}
            >
                {label}
                {props.mandatory ? <Icon icon={IconType.asterisk} state={BtnState.active}/> : (null)}
            </label>
        ) : (null);
    };
    const onChange = (ev: any) => {
        let isValid = props.checkValidity ? props.checkValidity(ev.target.value, props.mandatory) : true;
        if (!props.mandatory && ev.target.value.length === 0) {
            isValid = true;
        }
        if (props.mandatory && ev.target.value.length === 0) {
            isValid = false;
        }
        setError((!isValid) || props.error);
        if (props.setState) {
            props.setState(props.id, ev.target.value, isValid);
        }
    }

    useEffect(() => {
        setType(props.type);
    }, [props.type]);
    useEffect(() => {
        if (document.activeElement === ref.current) setError(props.error);
    }, [props.error]);
    useEffect(() => {
        if (props.mandatory) {
            setError(false);
        }
    }, [props.mandatory]);
    return (
        <div 
            className={`${props.className} ${showerror && error ? "inputError" : ""}`}
            onClick={() => ref.current.focus()}
        >
            {renderLabel(props.label)}
            <div 
                className={`input ${props.additional ? "grid" : ""}`}
            >
                <input
                    id={props.id}
                    name={props.id}
                    ref={ref}
                    type={type}
                    maxLength={props.length}
                    value={props.value ? props.value : ""}
                    onChange={onChange}
                    onBlur={(ev: any) => {setShowError(true); onChange(ev); setFocus(false); if (props.onBlur) props.onBlur()}}
                    onDoubleClick={props.onDoubleClick}
                    placeholder={(focus || !props.label) && !props.value?.length ? props.placeholder : ""}
                    onFocus={() => setFocus(true)}
                    disabled={props.disabled}
                    readOnly={props.readOnly}
                    autoComplete ={props.autoComplete ? props.autoComplete : "off"}
                    tabIndex={props.tabIndex !== undefined ? props.tabIndex : -1}
                    autoFocus={props.tabIndex === 1}
                />
                {props.additional === "eye" ? eye() : props.additional}
            </div>
            <div className="input_error_msg">{(showerror && error) ? props.validInfo : ""}</div>
        </div>
    );
}
export default (CustomInputValidity);
